import React, { useEffect, useState } from "react";
import BenefitPlansContext from "./context";
import fetchBenefitPlans from "../../../../../services/benefitPlan/fetchBenefitPlans";
import BenefitPlan from "../../../../../app/domain/BenefitPlan";

export default function BenefitPlansWrapper(props: any) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [benefitPlans, setBenefitPlans] = useState<BenefitPlan[]>([]);

  useEffect(() => {
    const loadBenefitPlans = async () => {
      setIsLoading(true);
      await fetchBenefitPlans({ callback: setBenefitPlans });
      setIsLoading(false);
    };
    loadBenefitPlans();
  }, []);

  return (
    <BenefitPlansContext.Provider
      value={{ benefitPlans, setBenefitPlans, isLoading, setIsLoading }}
      {...props}
    />
  );
}
